"use client";

let isAuthRedirecting = false;

const AUTH_MARKERS = [
  "autherror",
  "eauth_invalid",
  "eauth_unauthorized",
  "invalid auth",
  "invalid auth context",
  "unauthorized response",
  "fetchwithtimeout.unauthorized",
];

const asText = (value: unknown): string => {
  if (typeof value === "string") return value;
  if (value instanceof Error) {
    const code = String((value as any)?.code || "");
    return `${value.name || ""} ${code} ${value.message || ""}`.trim();
  }
  try {
    return JSON.stringify(value);
  } catch {
    return String(value ?? "");
  }
};

export const isAuthErrorLike = (value: unknown): boolean => {
  if (value && typeof value === "object") {
    const errLike = value as {
      name?: unknown;
      type?: unknown;
      status?: unknown;
      code?: unknown;
      source?: unknown;
      message?: unknown;
    };

    const name = String(errLike.name ?? errLike.type ?? "").toLowerCase();
    const status = Number(errLike.status);
    const code = String(errLike.code ?? "").toLowerCase();
    const source = String(errLike.source ?? "").toLowerCase();
    const message = String(errLike.message ?? "").toLowerCase();

    if (
      status === 401 &&
      (name.includes("autherror") ||
        code.includes("eauth") ||
        source.includes("fetchwithtimeout.unauthorized") ||
        message.includes("unauthorized"))
    ) {
      return true;
    }
  }

  const haystack = asText(value).toLowerCase();
  if (!haystack) return false;
  if (AUTH_MARKERS.some((marker) => haystack.includes(marker))) {
    return true;
  }
  return haystack.includes("status: 401") && haystack.includes("autherror");
};

export const signOutAndGoToSignIn = async () => {
  if (isAuthRedirecting || typeof window === "undefined") return;
  isAuthRedirecting = true;

  try {
    window.sessionStorage.setItem(
      "auth_redirect_notice",
      "Session ends, please login again",
    );
  } catch {
    // ignore storage failures
  }

  try {
    const { signOut } = await import("@/lib/actions/user.actions");
    await signOut();
  } catch {
    // ignore signout failures; navigation still clears via middleware/sign-in path
  } finally {
    window.location.assign("/sign-in");
  }
};
